define.alias("checkout/components/seamless-checkout/review-changes-modal", "settings/components/seamless-checkout/review-changes-modal");